import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { motion } from 'motion/react';

export default function Required() {
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="required-tooltip-top" className="text-danger">
          Ce champ est obligatoire
        </Tooltip>
      }
    >
      <motion.span
        initial={{ opacity: 0, fontSize: '1rem' }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        whileHover={{ fontSize: '0.9rem' }}
        className="text-danger"
      >
        &nbsp;*
      </motion.span>
    </OverlayTrigger>
  );
}
